import { ActionLink } from './ErrorActions'
import { ErrorState } from './ErrorState'

/**
 * `/*` inside the Layout shell.
 *
 * KEEPS THE APP CHROME, which is the one real decision on this screen. Coinbase
 * renders its 404 inside the content area with the rail still standing, and
 * that is right for an authenticated app: a user who mistyped a URL has not
 * lost their session, and taking the navigation away from them turns a wrong
 * turn into a dead end. It is a child of the shell in `router.tsx` for exactly
 * this reason, which also means it inherits `RequireFirstRun` and so a signed
 * out visitor still lands on `/login` rather than on a 404 in an empty frame.
 *
 * A CLIENT-SIDE `<Link>`, unlike the route-error screen's document load.
 * Nothing is broken here, so there is no bad state to boot away from and no
 * reason to make the user pay for a full reload.
 */
export function NotFound() {
  return (
    <ErrorState
      eyebrow="404"
      title="Page not found"
      body="We could not find that page. It may have moved, or the address has a typo."
      className="py-20 sm:py-28"
      actions={<ActionLink to="/">Back to home</ActionLink>}
    />
  )
}
